'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var nthHookTheme = require('@narvar/nth-hook-theme');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function (ButtonType) {
  ButtonType["button"] = "button";
  ButtonType["submit"] = "submit";
})(exports.ButtonType || (exports.ButtonType = {}));
(function (ButtonTargetType) {
  ButtonTargetType["self"] = "_self";
  ButtonTargetType["blank"] = "_blank";
})(exports.ButtonTargetType || (exports.ButtonTargetType = {}));
var primaryStyles = function primaryStyles(_ref) {
  var buttonStyleDefault = _ref.buttonStyleDefault,
    buttonStyleDisabled = _ref.buttonStyleDisabled,
    buttonStyleHover = _ref.buttonStyleHover;
  return _objectSpread(_objectSpread({}, buttonStyleDefault), {}, {
    '&:active': {
      backgroundColor: '#286090'
    },
    '&:hover': _objectSpread({
      borderColor: '#286090',
      backgroundColor: '#286090',
      color: '#fff'
    }, buttonStyleHover),
    '&:disabled': _objectSpread({
      borderColor: '#cccccc',
      backgroundColor: '#cccccc',
      cursor: 'not-allowed'
    }, buttonStyleDisabled)
  });
};
var outlineStyles = function outlineStyles(_ref2) {
  var outlineStyleDefault = _ref2.outlineStyleDefault,
    outlineStyleDisabled = _ref2.outlineStyleDisabled,
    outlineStyleHover = _ref2.outlineStyleHover;
  var base = _objectSpread({
    borderStyle: 'solid',
    borderColor: '#2b7cac',
    borderWidth: '1px',
    backgroundColor: 'transparent',
    color: '#2b7cac'
  }, outlineStyleDefault);
  return _objectSpread(_objectSpread({}, base), {}, {
    '&:active': {
      borderWidth: '0.25rem'
    },
    '&:hover': _objectSpread({
      borderColor: '#286090',
      color: '#286090'
    }, outlineStyleHover),
    '&:disabled': _objectSpread({
      borderColor: '#ccc',
      cursor: 'not-allowed',
      color: '#ccc'
    }, outlineStyleDisabled)
  });
};
var StyledButton = styled.button.withConfig({
  componentId: "sc-1qt8hwk-0"
})(function (_ref3) {
  var s = _ref3.s;
  return _objectSpread({
    display: 'inline-block',
    position: 'relative',
    textDecoration: 'none',
    textAlign: 'center',
    width: s && s.big ? '100%' : 'auto',
    height: 'auto',
    minWidth: '6.25rem',
    margin: 0,
    padding: '0.625rem 1.5rem',
    borderStyle: 'none',
    borderColor: '#2b7cac',
    borderWidth: '0.0625rem',
    borderRadius: '0.125rem',
    lineHeight: '1.25rem',
    fontFamily: 'inherit',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    backgroundColor: '#2b7cac',
    color: '#fff',
    cursor: 'pointer'
  }, s && s.outline ? s.sOutline : s && s.sPrimary);
});
var Button = function Button(_ref4) {
  var onClick = _ref4.onClick,
    href = _ref4.href,
    target = _ref4.target,
    _ref4$type = _ref4.type,
    type = _ref4$type === void 0 ? exports.ButtonType.button : _ref4$type,
    big = _ref4.big,
    disabled = _ref4.disabled,
    outline = _ref4.outline,
    children = _ref4.children,
    className = _ref4.className;
  var _useTheme = nthHookTheme.useTheme(),
    buttonStyleDefault = _useTheme.buttonsPrimaryDefault,
    buttonStyleDisabled = _useTheme.buttonsPrimaryDisabled,
    buttonStyleHover = _useTheme.buttonsPrimaryHover,
    outlineStyleDefault = _useTheme.buttonsSecondaryDefault,
    outlineStyleDisabled = _useTheme.buttonsSecondaryDisabled,
    outlineStyleHover = _useTheme.buttonsSecondaryHover;
  var button = /*#__PURE__*/React.createElement(StyledButton, {
    s: {
      sPrimary: primaryStyles({
        buttonStyleDefault: buttonStyleDefault,
        buttonStyleDisabled: buttonStyleDisabled,
        buttonStyleHover: buttonStyleHover
      }),
      sOutline: outlineStyles({
        outlineStyleDefault: outlineStyleDefault,
        outlineStyleDisabled: outlineStyleDisabled,
        outlineStyleHover: outlineStyleHover
      }),
      big: big,
      outline: outline
    },
    disabled: disabled,
    onClick: href || disabled ? undefined : onClick,
    type: href ? undefined : type,
    className: className
  }, children);
  if (href) {
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      target: target || exports.ButtonTargetType.blank,
      rel: "noreferrer noopener",
      onClick: onClick
    }, button);
  }
  return button;
};
Button.defaultProps = {
  onClick: undefined,
  href: undefined,
  target: undefined,
  type: undefined,
  big: false,
  disabled: undefined,
  outline: false
};
Button.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.oneOf([exports.ButtonTargetType.self, exports.ButtonTargetType.blank]),
  children: PropTypes.node,
  type: PropTypes.oneOf([exports.ButtonType.button, exports.ButtonType.submit]),
  big: PropTypes.bool,
  disabled: PropTypes.bool,
  outline: PropTypes.bool
};
var index = nthHookTheme.withThemeProvider(Button, {
  themeTokens: ['buttonsPrimaryDefault', 'buttonsPrimaryDisabled', 'buttonsPrimaryHover', 'buttonsSecondaryDefault', 'buttonsSecondaryDisabled', 'buttonsSecondaryHover']
});

exports.default = index;
exports.outlineStyles = outlineStyles;
exports.primaryStyles = primaryStyles;
